<template>
  <v-card tile flat class="result-text theme-title transparent appbar-result-action">
    {{ this.team_a_set_score }}
    <span class="score-spacer ml-1 mr-1 theme-title"> - </span>
    {{ this.team_b_set_score }}
  </v-card>
</template>

<script>
/* STRAND - TeamSetScores - src/components/strand/TeamSetScores.vue */
import CONSTANTS from '@/constants';
import eventBus from '@/eventBus';
import { mapState } from 'vuex'; // Importáljuk a mapState-et

export default {
  name: "TeamSetScores",
  // A gamedata propra már nem feltétlen van szükség az adatokhoz,
  // de ha máshol használják, maradhat. A currentPeriod is jöhetne Store-ból.
  props: {
    gamedata: Object,
    currentPeriod: String
  },
  data() {
    return {
      team_a_set_score: 0,
      team_b_set_score: 0,
      // timelineData TÖRÖLVE innen, mert computed lett
      singleScoreActions: [],
      doubleScoreActions: [],
      // set_scores objektum maradhat, ha bővíteni akarod, de jelenleg csak a primitíveket használjuk
    }
  },
  computed: {
    // Bekötjük a Store-ból a timelineData-t és a currentPeriod-ot
    ...mapState('game', ['timelineData', 'currentPeriod']),

    // Segéd a period intté konvertálásához
    periodInt() {
      return parseInt(this.currentPeriod);
    }
  },
  watch: {
    // Ha változik a timeline (gól, törlés, javítás), azonnal újraszámol
    timelineData: {
      handler() {
        this.calculateSetScores();
      },
      deep: true
    },
    // Ha változik a félidő, újra kell számolni a szetteket
    currentPeriod() {
      this.calculateSetScores();
    }
  },
  methods: {
    calculateSetScores() {
      let self = this;
      let team_a_scores = {
        first_period_score: 0,
        second_period_score: 0,
        final_period_score: 0,
      };
      let team_b_scores = {
        first_period_score: 0,
        second_period_score: 0,
        final_period_score: 0,
      };

      // Most már a this.timelineData a Store-ból jön
      if(self.timelineData) {
        self.timelineData.forEach(function(item) {
          let action = item.params && item.params.selectedAction && item.params.selectedAction.actionId ? item.params.selectedAction.actionId : item.action;
          let selectedTeam = item.params && item.params.selectedTeamId ? item.params.selectedTeamId : null;
          let increaseScoreBy = self.doubleScoreActions.includes(action) ? 2 : self.singleScoreActions.includes(action) ? 1 : 0;
          if(!item.deleted) {
            // 1: első félidő | 3: második félidő | 12: szétlövés
            switch (parseInt(item.period)) {
              case 1:
                team_a_scores.first_period_score += (selectedTeam === "teamA" ? increaseScoreBy : 0);
                team_b_scores.first_period_score += (selectedTeam === "teamB" ? increaseScoreBy : 0);
                break;
              case 3:
                team_a_scores.second_period_score += (selectedTeam === "teamA" ? increaseScoreBy : 0);
                team_b_scores.second_period_score += (selectedTeam === "teamB" ? increaseScoreBy : 0);
                break;
              case 12:
                team_a_scores.final_period_score += (selectedTeam === "teamA" ? increaseScoreBy : 0);
                team_b_scores.final_period_score += (selectedTeam === "teamB" ? increaseScoreBy : 0);
                break;
            }
          }
        });

        // Eredmények kiszámítása
        self.team_a_set_score = 0;
        self.team_b_set_score = 0;

        if(self.periodInt > 0) {
          // 1. félidő
          if (team_a_scores.first_period_score > team_b_scores.first_period_score) self.team_a_set_score++;
          if (team_b_scores.first_period_score > team_a_scores.first_period_score) self.team_b_set_score++;

          // 2. félidő (3-as kód)
          if(self.periodInt >= 3) {
            if (team_a_scores.second_period_score > team_b_scores.second_period_score) self.team_a_set_score++;
            if (team_b_scores.second_period_score > team_a_scores.second_period_score) self.team_b_set_score++;
          }

          // Szétlövés (12-es kód)
          if(self.periodInt >= 12) {
            if (team_a_scores.final_period_score > team_b_scores.final_period_score) self.team_a_set_score++;
            if (team_b_scores.final_period_score > team_a_scores.final_period_score) self.team_b_set_score++;
          }
        }

        // Szétlövés engedélyezése/tiltása (EventBus maradhat a kommunikációhoz)
        if(self.periodInt > 3 && self.team_a_set_score === self.team_b_set_score) {
          eventBus.$emit(CONSTANTS.EVENTS.PERIOD.ENABLE.SHOOTOUT, true);
        }
        else {
          eventBus.$emit(CONSTANTS.EVENTS.PERIOD.ENABLE.SHOOTOUT, false);
        }
      }
    },
  },
  mounted() {
    // Inicializálás
    this.singleScoreActions = CONSTANTS.ACTIONS.SINGLE_SCORE_ACTIONS;
    this.doubleScoreActions = CONSTANTS.ACTIONS.DOUBLE_SCORE_ACTIONS;

    // Első számolás
    this.calculateSetScores();
  },
}
</script>

<style scoped>
@font-face {
  font-family: TickingTimebombBB;
  src: url('~@/assets/TickingTimebombBB.otf') format("opentype");
}

.main-result.result-text {
  min-width: 34px;
}

.appbar-result-action.result-text {
  font-family: TickingTimebombBB;
  font-size: 33px;
  font-style: normal;
  background: transparent;
}
</style>
